import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledCarouselHeader } from './CarouselHeader.styles';

/**
 * Wrapper for the Carousel header content including the heading text
 * and navigation controls.
 *
 * @since 8.71.0
 */
export var CarouselHeader = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledCarouselHeader, _extends({
    ref: forwardedRef
  }, props));
});
CarouselHeader.displayName = 'CarouselHeader';